import { useMemo } from 'react';
import { useGetCustomFieldsListQuery } from 'store/api/custom-fields';
import { CustomField } from 'types/customFields';

export const useCustomFieldsList = (entityType: string) => {
    const { data: customFields, isLoading } = useGetCustomFieldsListQuery();

    const customFieldObject = useMemo<Record<string, CustomField>>(() => {
        if (!customFields) return {};
        const collectedCustomFields = {} as Record<string, CustomField>;
        customFields.forEach((customField) => {
            if (entityType === customField.entityType) {
                collectedCustomFields[customField.entityType] = customField;
            }
        });
        return collectedCustomFields;
    }, [customFields, entityType]);

    const filteredCustomFields = useMemo(
        () => customFields?.filter((field) => field.entityType === entityType),
        [customFields, entityType]
    );

    return {
        customFields: customFieldObject,
        customFieldsArray: filteredCustomFields ?? [],
        allCustomFields: customFields ?? [],
        isLoading: isLoading,
    };
};
